module.exports = __webpack_public_path__ + "img/banner1.c2b8a5a8.png";